module.exports = __webpack_public_path__ + "img/CodeGraphy.5df5e510.png";